import { render, staticRenderFns } from "./TifProyeccionPlantaExterna.vue?vue&type=template&id=af58c0da"
import script from "./TifProyeccionPlantaExterna.vue?vue&type=script&lang=js"
export * from "./TifProyeccionPlantaExterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports